import { InGuardGenerate } from "@/shared/guards";
import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import AdminStore from "../store";
/**
 * Pages
 */
import OpportunitiesPage from "../views/opportunities-page/opportunities.page.vue";
import UsersPage from "../views/users-page/users-page.vue";
import TransactionsPage from "../views/transactions/transactions-page.vue";
import BiddingsPage from "../views/biddings/biddings-page.vue";
import InvitationsPage from "../views/invitations/invitations-page.vue";
import BusinessesPage from "../views/businesses/businesses-page.vue";
/**
 *
 */
import AdminRouterApp from "../views/Router.App.vue";
/**
 *
 */
const routes: Array<RouteRecordRaw> = [
  {
    path: "",
    beforeEnter: InGuardGenerate(AdminStore),
    component: AdminRouterApp,
    children: [
      {
        path: "",
        redirect: "users",
      },
      {
        path: "users",
        component: UsersPage,
      },
      {
        path: "opportunities",
        component: OpportunitiesPage,
      },
      {
        path: "transactions",
        component: TransactionsPage,
      },
      {
        path: "biddings",
        component: BiddingsPage,
      },
      {
        path: "invitations",
        component: InvitationsPage,
      },
      {
        path: "startups",
        component: BusinessesPage,
      },
    ],
  },
];

export const AdminRouter = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default AdminRouter;
